import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'aw-to-be-implemented-placeholder',
  templateUrl: './to-be-implemented-placeholder.component.html',
  styleUrls: ['./to-be-implemented-placeholder.component.scss']
})
export class TO_BE_IMPLEMENTED_PLACEHOLDER_COMPONENT implements OnInit {
  config: string[] = [];

  constructor(public router: Router) {
  }

  ngOnInit(): void {
    //this.printpath('', this.router.config);
  }

  //printpath(parent: string, config: Route[]): void {
  //  for (let i = 0; i < config.length; i++) {
  //    const route = config[i];
  //    this.config.push(parent + '/' + route.path);
  //    if (route.children) {
  //      const currentPath = route.path ? parent + '/' + route.path : parent;
  //      this.printpath(currentPath, route.children);
  //    }
  //  }
  //}

}
